import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Title from "./Title";
import useStyles from "./landingStyle-jss";
import "./Landing.css";

let counter = 0;
function createFeatureData(icon, title, desc) {
  counter += 1;
  return {
    id: counter,
    icon,
    title,
    desc,
  };
}

function Feature(props) {
  const { slideMode } = props;
  const { classes, cx } = useStyles();
  const featureList = [
    createFeatureData(
      "ion-ios-infinite-outline",
      "Learning ",
      "awareness activities in the area of Information Security and integrate them on to a common platform to enable students, researchers, faculty, professionals, general public, etc."
    ),
    createFeatureData(
      "ion-ios-flower-outline",
      "Common Interface",
      "Act as a common interface to facilitate collaborative activities & resource sharing within and across the thematic clusters to solve challenging problems in the domain of Cyber Security."
    ),
    createFeatureData(
      "ion-ios-ionic-outline",
      "Exchange of Thoughts",
      "Facilitate exchange of thoughts, knowledge, expertise, participate/engage with the ideas and resources to enhance their learning experience, etc., across a larger community through ISEA platform."
    ),
  ];

  return (
    <div
      className={cx(classes.feature, slideMode ? classes.mono : classes.color)}
    >
      <div className={!slideMode ? classes.container : ""}>
        <Title
          title=" About IVP"
          align="center"
          monocolor={slideMode && true}
        />
        <p>
          The COVID-19 situation has forced organizations, including educational
          institutions, to use digital technologies during the crisis. Digital
          infrastructures had to be rapidly scaledup to match the exceptional
          circumstances. This has led to an enhanced digital security risk
          during crises because stressed organizations, especially in
          healthcare, education sectors, etc. are more vulnerable to attacks
        </p>
        <Grid
          container
          className={` gridContainer ${classes.root}`}
          spacing={5}
        >
          {featureList.map((item) => (
            <Grid
              className="featureGridCard"
              key={item.id.toString()}
              item
              xs={12}
              md={4}
            >
              <Typography component="h4" variant="h6">
                <span className={classes.icon}>
                  <i className={item.icon} />
                </span>
                {item.title}
              </Typography>
              <Typography className={slideMode ? classes.colorWhite : ""}>
                {item.desc}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

Feature.propTypes = {
  slideMode: PropTypes.bool,
};

Feature.defaultProps = {
  slideMode: false,
};

export default Feature;
